import classNames from 'classnames';
import { ForwardedRef, forwardRef } from 'react';

import { getUrlParam } from '~globals/common';

export type CardWithIconAndBannerProps = {
    title: string;
    body: string;
    imageurl: string;
    index: number;
    backgroundsurface: SupportedBackgroundColor;
    textcolor: SupportedTextColor;
    minwidths: string;
    bannertype?: 'Coming Soon';
    urlflag?: 'DSNP';
};

const CardWithIconAndBanner = forwardRef(function RefCard(
    {
        imageurl,
        title,
        body,
        index,
        backgroundsurface,
        textcolor,
        minwidths,
        bannertype,
        urlflag,
    }: CardWithIconAndBannerProps,
    ref: ForwardedRef<HTMLDivElement | null>
) {
    const doesRenderWithCurrentFlag = () => {
        if (!urlflag) {
            return true;
        }
        if (urlflag.includes(':hide')) {
            const actualFlag = urlflag.replace(':hide', '');
            return getUrlParam(actualFlag) !== 'true';
        }
        return getUrlParam(urlflag) === 'true';
    };

    if (!doesRenderWithCurrentFlag()) return null;

    return (
        <div
            ref={ref}
            className={classNames(
                'icon-banner-card relative',
                'flex flex-col items-center self-stretch',
                'px-3 py-8 lg:px-5 lg:py-10',
                'overflow-hidden',
                'snap-center md:snap-align-none',
                'rounded-md shadow',
                minwidths,
                backgroundsurface,
                textcolor as string
            )}
            data-index={index}
        >
            {bannertype && (
                <div
                    className={classNames(
                        'bg-icon-primary text-white font-bold',
                        'transform rotate-45 leading-24',
                        'absolute top-8 -right-20 md:-right-24 lg:-right-28 w-full'
                    )}
                >
                    {bannertype}
                </div>
            )}
            <img
                alt=""
                src={imageurl}
                width={80}
                height={80}
                className="lg:w-[105px] lg:h-[105px] mb-5"
            />
            <h4
                className={classNames(
                    'text-18 leading-28',
                    'md:text-20 md:leading-28',
                    'lg:text-24 lg:leading-32',
                    'font-bold font-poppins',
                    'text-center',
                    'mb-3 lg:mb-6'
                )}
                dangerouslySetInnerHTML={{ __html: title }}
            ></h4>
            <p
                className="text-16 leading-24 text-center"
                dangerouslySetInnerHTML={{ __html: body }}
            ></p>
        </div>
    );
});

CardWithIconAndBanner.displayName = 'CardWithIconAndBanner';

export default CardWithIconAndBanner;
